import { useQuery } from 'react-query'
import { highlights } from 'services/api'
import { isCallAllowed } from 'configs'
import { LocalId } from 'globalTypes'

export function useHighlights(localId: LocalId) {
  return useQuery(
    ['highlights', localId.id, localId.country],
    () => highlights(localId),
    {
      enabled: !!isCallAllowed('highlights', localId.country),
      retry: false,
      refetchOnWindowFocus: false,
    },
  )
}
